import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectDarkMode } from "../../../../app/store/slices/uiSlice";
import ConfirmModal from "../ConfirmModal";

export default function FormToggle({
  label,
  name,
  checked = false,
  onChange,
  onBlur,
  disabled = false,
  required = false,
  error = "",
  className = "",
  hideLabel = false,
  // Confirmation modal props
  requireConfirmation = () => false,
  confirmTitle = "Confirm Status Change",
  confirmMessage = "Are you sure you want to change the status?",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
}) {

  const darkMode = useSelector(selectDarkMode);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingValue, setPendingValue] = useState(null);

  const handleChange = (e) => {

    if (requireConfirmation(e.target.checked)) {

      // Store the pending value and show confirmation modal
      setPendingValue(e.target.checked);
      setShowConfirmModal(true);
    } else {
      // Direct change without confirmation
      if (onChange) {
        onChange(e);
      }
    }
  };

  const handleConfirm = () => {
    if (onChange && pendingValue !== null) {
      // Create a synthetic event-like object
      onChange({ target: { name, checked: pendingValue } });
    }
    setShowConfirmModal(false);
    setPendingValue(null);
  };

  const handleCancel = () => {
    setShowConfirmModal(false);
    setPendingValue(null);
  };

  return (
    <>
      <div className={`form-group ${className}`}>
        <label
          className={`flex items-center gap-3 cursor-pointer select-none ${disabled ? "cursor-not-allowed opacity-60" : ""
            } ${darkMode ? "text-gray-200" : "text-[#232526]"}`}
        >
          <div className="relative">
            <input
              type="checkbox"
              name={name}
              checked={checked}
              onChange={handleChange}
              onBlur={onBlur}
              disabled={disabled}
              className="sr-only peer"
            />
            {/* Toggle Track */}
            <div
              className={`
                w-11 h-6 rounded-full transition-colors duration-200
                ${checked
                  ? "bg-emerald-500"
                  : darkMode
                    ? "bg-gray-600"
                    : "bg-gray-300"
                }
                peer-focus:ring-2 peer-focus:ring-emerald-500 peer-focus:ring-offset-2
                ${darkMode ? "peer-focus:ring-offset-gray-800" : "peer-focus:ring-offset-white"}
                ${disabled ? "opacity-50" : ""}
              `}
            />
            {/* Toggle Knob */}
            <div
              className={`
                absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow-md
                transition-transform duration-200 ease-in-out
                ${checked ? "translate-x-5" : "translate-x-0"}
              `}
            />
          </div>
          {!hideLabel && label && (
            <span className="text-sm font-medium">
              {label}
              {required && <span className="text-red-500"> *</span>}
            </span>
          )}
        </label>

        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
      </div>

      {/* Confirmation Modal */}
      <ConfirmModal
        isOpen={showConfirmModal}
        title={confirmTitle}
        message={typeof confirmMessage === 'function'
          ? confirmMessage(pendingValue)
          : confirmMessage}
        confirmLabel={confirmLabel}
        cancelLabel={cancelLabel}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </>
  );
}
